/**
 * Registra o service worker apenas em produção e depois do load,
 * para não competir com o LCP nem interferir no HMR do dev.
 */
export function registerSW() {
  if (!("serviceWorker" in navigator)) return;

  if (!import.meta.env.PROD) {
    // Em dev, garante que nenhum SW antigo sirva conteúdo obsoleto.
    navigator.serviceWorker.getRegistrations().then((rs) => rs.forEach((r) => r.unregister()));
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* silencioso: performance é progressive enhancement */
    });
  });
}
